<app-page-heading [key]="'hotspots.alerts.page-title'"></app-page-heading>

<section class="container-fluid summary-panel">

    <app-data-table [columns]="columns" [sortColumn]="sortColumn" [loadPage]="loadPage" [(filters)]="filters" (onReset)="resetFilters()" [filtersComponent]="dataFilters" (onLoad)="pageLoaded()">
        <app-data-filters #dataFilters>
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-input [labelKey]="'hotspots.alerts.filters.user-id.label'" [(model)]="filters.user_id"
                                             [placeholderKey]="'hotspots.alerts.filters.user-id.placeholder'"></app-data-filter-input>

                <app-data-filter-select [labelKey]="'hotspots.alerts.filters.region.label'" [(model)]="filters.region_id"
                                              [options]="regions"></app-data-filter-select>

                <app-data-filter-input [labelKey]="'hotspots.alerts.filters.load-id.label'" [(model)]="filters.load_id"
                                             [placeholderKey]="'hotspots.alerts.filters.load-id.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'hotspots.alerts.filters.load-number.label'" [(model)]="filters.load_number"
                                             [placeholderKey]="'hotspots.alerts.filters.load-number.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'hotspots.alerts.filters.vehicle-id.label'" [(model)]="filters.vehicle_id"
                                            [placeholderKey]="'hotspots.alerts.filters.vehicle-id.placeholder'"></app-data-filter-input>

            </app-data-filter-group>
            <app-data-filter-group [useAvailableWidth]="true">

                <app-data-filter-input [labelKey]="'hotspots.alerts.filters.hotspot-alert-id.label'" [(model)]="filters.alert_id"
                                             [placeholderKey]="'hotspots.alerts.filters.hotspot-alert-id.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'hotspots.alerts.filters.hotspot-label.label'" [(model)]="filters.hotspot_label"
                                             [placeholderKey]="'hotspots.alerts.filters.hotspot-label.placeholder'"></app-data-filter-input>

                <app-data-filter-select [labelKey]="'hotspots.alerts.filters.hotspot-type.label'" [(model)]="filters.hotspot_type"
                                              [options]="hotspotsTypesOptions"></app-data-filter-select>

                <app-data-filter-date [labelKey]="'hotspots.alerts.filters.between.start.label'" [(model)]="startDate"
                                            [maxDate]="endDate || filtersMaxDate" [placeholderKey]="'hotspots.alerts.filters.between.start.placeholder'"
                                            (modelChange)="updateDateFilters()"></app-data-filter-date>

                <app-data-filter-date [labelKey]="'hotspots.alerts.filters.between.end.label'" [(model)]="endDate"
                                            [minDate]="startDate" [maxDate]="filtersMaxDate" [placeholderKey]="'hotspots.alerts.filters.between.end.placeholder'"
                                            (modelChange)="updateDateFilters()"></app-data-filter-date>
            </app-data-filter-group>
        </app-data-filters>
    </app-data-table>

</section>


<ng-template #userIdColumn let-userId="userId">
    {{userId}}
</ng-template>

<ng-template #regionColumn let-region="region">
    <a class="cmaweb-link"
       *ngIf="canAccessRegionManagementScreen; else displayOnly"
       [href]="link.goToRegion(region)"
       target="_blank">
        {{region}}
    </a>
    <ng-template #displayOnly>
        {{region}}
    </ng-template>
</ng-template>

<ng-template #loadsIdsColumn let-loadsIds="loadsIds">
    {{loadsIds.join(', ')}}
</ng-template>

<ng-template #loadsNumbersColumn let-loadsNumbers="loadsNumbers">
    <a class="cmaweb-link" [href]="link.goToLoadManagementForLoad(loadsNumbers.join(', '))" target="_blank">{{loadsNumbers.join(', ')}}</a>
</ng-template>

<ng-template #vehicleIdColumn let-vehicleId="vehicleId">
    {{vehicleId}}
</ng-template>

<ng-template #hotspotColumn let-hotspot="hotspot">
    <app-hotspot-type-icon class="m-r-sm" [type]="hotspot.type"></app-hotspot-type-icon>
    <a (click)="goToHotspot(hotspot.id)">{{hotspot.label}}</a>
</ng-template>

<ng-template #enteredAtColumn let-enteredAt="enteredAt">
    {{enteredAt | fullDate}}
</ng-template>

<ng-template #leftAtColumn let-leftAt="leftAt">
    {{leftAt | fullDate}}
</ng-template>

<ng-template #recordedAtColumn let-recordedAt="recordedAt">
    {{recordedAt | fullDate}}
</ng-template>
